import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  Output,
  ViewChild,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import chroma from "chroma-js";
import { flatten, getSubjectColor } from "../shared/helpers/util";
import {
  Domain,
  Goal,
  LearningObjective,
  LearningObjectiveVM,
  Subject,
} from "../shared/model/model";
import { LearningObjectiveViewComponent } from "../learning-objective-view/learning-objective-view.component";
@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, LearningObjectiveViewComponent],
  selector: "app-learning-objective-categories-spelling",
  templateUrl: "./learning-objective-categories-spelling.component.html",
  styleUrls: ["./learning-objective-categories-spelling.component.scss"],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class LearningObjectiveCategoriesSpellingComponent
  implements AfterViewInit
{
  selectedGoal: Goal;
  selectedSubjects: Array<Subject> = [];
  scrollPositionSelected = 0;
  // Helper array for looking up goals
  goals: Array<Goal>;
  jsPlumb: any; // jsPlumbInstance;

  public selectedLearningObjective: LearningObjectiveVM;
  private inList: string[];

  @ViewChild("subjectContainer", { static: true }) subjectCo: ElementRef;

  // zIndex = 10000;
  @Input() readOnly = true;
  @Input() learningObjectivesPlanned: Array<LearningObjective>;
  @Input() learningObjectivesOrdered: Array<LearningObjective>;
  @Input() editMode: boolean;
  @Input() domain: Domain;
  @Input() allLearningObjectives: Array<LearningObjectiveVM>;
  @Input() learningObjectivesInList: Array<LearningObjectiveVM>;

  settingDomain: boolean;

  @Input("selected")
  set selected(lo: LearningObjectiveVM) {
    this.selectedLearningObjective = lo;
    
    if (lo) {
      // select goal if learning objective is selected and already opened
      const openGoal = (<Array<Goal>>(
        flatten(this.selectedSubjects.map((s) => s.goals))
      )).find((g) => !!g.learningObjectives.find((l) => l.id === lo.id));
    }
  }

  @Output() addLearningObjective: EventEmitter<LearningObjective> =
    new EventEmitter();
  @Output() removeLearningObjective: EventEmitter<LearningObjective> =
    new EventEmitter();
  @Output() learningObjectiveSelected: EventEmitter<LearningObjective> =
    new EventEmitter();

  constructor(private elRef: ElementRef, private zone: NgZone) {}
  public colorScale = (domainId: string, subjectId: string) =>
    getSubjectColor(domainId, subjectId);
  public colorLightScale = (domainId: string, subjectId: string) =>
    chroma(getSubjectColor(domainId, subjectId)).luminance(0.8);

  ngAfterViewInit() {}

  toggleLearningObjectiveHandler(lo: LearningObjectiveVM) {
    if (lo.inList) {
      this.removeLearningObjective.emit(lo);
    } else {
      this.addLearningObjective.emit(lo);
    }
  }

  idLearningObjective(index, item: any) {
    return item ? item.id : index;
  }

  public select = (learningObjective: LearningObjectiveVM) => {
    if (!learningObjective.inList) {
      learningObjective = { ...learningObjective, inList: false };
    }
    this.learningObjectiveSelected.emit(learningObjective);
  };
}
